import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { AlertTriangle, Trash2 } from "lucide-react";

/** Stateless presentation of orphan cases. Parent owns the data + delete handler. */
export default function OrphansPanel({ orphans, onClose, onDelete }) {
  if (!orphans || orphans.length === 0) return null;
  return (
    <Card className="border-amber-300 bg-amber-50/30" data-testid="orphans-panel">
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="font-display text-lg font-semibold text-amber-900 flex items-center gap-2">
              <AlertTriangle className="h-5 w-5" /> {orphans.length} caso(s) órfão(s) detectado(s)
            </h2>
            <p className="text-xs text-amber-800 mt-1">
              Estes casos estão no banco mas não têm linha correspondente no mapa filtrado.
              Provavelmente a linha foi excluída depois do caso ter sido gerado, mas o caso
              não foi excluído junto. Eles aparecem em Produção/Faturamento mas não vão refletir
              na soma manual do mapa filtrado.
            </p>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} className="text-amber-700">Fechar</Button>
        </div>
        <div className="border border-amber-200 rounded-md bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-amber-100 text-xs uppercase tracking-wider text-amber-900">
              <tr>
                <th className="px-3 py-2 text-left">Código</th>
                <th className="px-3 py-2 text-left">Paciente</th>
                <th className="px-3 py-2 text-left">Procedimento</th>
                <th className="px-3 py-2 text-left">Data</th>
                <th className="px-3 py-2 text-left">Motivo</th>
                <th className="px-3 py-2 text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {orphans.map((o) => (
                <tr key={o.id} className="border-t border-amber-100" data-testid={`orphan-row-${o.case_code}`}>
                  <td className="px-3 py-2 font-mono text-xs">{o.case_code}</td>
                  <td className="px-3 py-2">{o.patient_name}</td>
                  <td className="px-3 py-2 text-slate-700">{o.procedure_name}</td>
                  <td className="px-3 py-2 text-slate-600">{o.surgery_date || "—"}</td>
                  <td className="px-3 py-2 text-amber-800 text-xs">{o.reason}</td>
                  <td className="px-3 py-2 text-right">
                    <div className="flex items-center justify-end gap-1">
                      <Link to={`/casos/${o.id}`} className="text-blue-600 text-xs hover:underline">Abrir</Link>
                      <Button size="sm" variant="ghost" className="text-red-600 hover:bg-red-50 hover:text-red-700 h-7 px-2"
                        onClick={() => onDelete(o)} data-testid={`btn-delete-orphan-${o.case_code}`} title="Excluir este caso">
                        <Trash2 className="h-3.5 w-3.5" />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
